import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import Image from 'presentations/views/components/atoms/Image';
import Headline from 'presentations/views/components/atoms/Headline';
import Link from 'presentations/views/components/atoms/Link';
import * as tracker from 'presentations/views/helpers/analytics';
import {
  resourceCategoryPath,
  enterpriseInquiryPath,
  customerStoryListPath,
} from 'presentations/routes/path';
import { spacing, fontSize, mediaMax } from 'presentations/views/styles';
import { gray04, primary } from 'presentations/views/styles/color';
import { ProductType } from 'domains/models/blog_post/productType';
import { SyntheticEvent, useMemo } from 'react';
import { getLandingPageUrl } from '../OwnedContentBanner';

interface Props {
  productType: ProductType;
}
export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const targetUrl = useMemo(() => {
    return getLandingPageUrl(props.productType);
  }, [props.productType]);
  const formUrl = enterpriseInquiryPath();
  const usecaseUrl = customerStoryListPath();

  const onClick = (e: SyntheticEvent) => {
    tracker.setEvent('click resource banner', {
      position: 'inline',
    });
  };
  const onClickInquiry = (e: SyntheticEvent) => {
    tracker.setEvent('click corporative inquiry', {
      source: 'jicoo',
      product: 'resource',
      position: 'inline',
    });
  };

  return (
    <>
      <InlineHeadline variant="h2">{t('Summary')}</InlineHeadline>
      <InlineSection>{t(`text_${props.productType}.0`)}</InlineSection>
      <figure>
        <Link href={targetUrl}>
          <InlineImage
            src="pages/resource/inline_image.png"
            alt=""
            width={672}
            height={406}
            dpr={2}
          />
        </Link>
      </figure>
      <InlineSection>
        <Link href={targetUrl} target="_blank" onClick={onClick}>
          {t(`text_${props.productType}.1`)}
        </Link>
        {t(`text_${props.productType}.2`)}
      </InlineSection>
      <InlineSection>
        <Link href={targetUrl} target="_blank" onClick={onClick}>
          {t(`text_${props.productType}.3`)}
        </Link>
        {t(`text_${props.productType}.4`)}
        <Link href={formUrl} target="_blank" onClick={onClickInquiry}>
          {t(`text_${props.productType}.5`)}
        </Link>
        {t(`text_${props.productType}.6`)}
      </InlineSection>
      <InlineSection>
        <Link href={usecaseUrl} target="_blank" onClick={onClick}>
          {t(`text_${props.productType}.7`)}
        </Link>
        {t(`text_${props.productType}.8`)}
      </InlineSection>
    </>
  );
}

const InlineHeadline = styled(Headline)`
  margin: 3rem 0 32px 0;
  font-size: ${fontSize(28)};
  line-height: 1.5;
  padding-bottom: ${spacing(24)};
  border-bottom: 1px solid ${primary};
`;
const InlineSection = styled.p`
  white-space: pre-wrap;
  letter-spacing: 0.05em;
  font-size: ${fontSize(16)};
  line-height: 1.8;
  margin-bottom: ${spacing(24)};
`;
const InlineImage = styled(Image)`
  ${mediaMax.tablet} {
    width: 100%;
    height: auto;
  }
`;
